import { useContext } from 'react';
import { youtubeVideo } from '../videos/youtubeVideo';
import { SelectionContext } from '../GridDndEditor/SelectedBlockInfoProvider';
import { useNewBlockContentObjectChangedHandler } from './useNewBlockContentObjectChangedHandler';
import type { VideoContent, VideoParser } from '../videos/video';
import { InvalidSource, InvalidUrl } from '../videos/videoErrors';
import { vimeoVideo } from '../videos/vimeoVideo';
import { useSelector } from 'react-redux';
import { selectBlockContent } from '../grid/reduxStore/editorSlice';
import type { RootState } from '../grid/reduxStore/Store';

export const useVideoWithUndoRedoBlockSettings = () => {
  const { selectedBlockInfoByWrapper } = useContext(SelectionContext);
  const newContentObjectChanged = useNewBlockContentObjectChangedHandler();

  const blockId = selectedBlockInfoByWrapper.blockId as string;
  const sectionId = selectedBlockInfoByWrapper.sectionId as string;

  const blockContent = useSelector((state: RootState) => selectBlockContent(state, sectionId, blockId));

  const videoParsers: VideoParser[] = [youtubeVideo, vimeoVideo];

  const getVideoDataFromUrl = async (url: string) => {
    const simpleUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
    if (!simpleUrlRegex.test(url)) {
      throw new InvalidUrl();
    }

    const parser = videoParsers.find((parser) => parser.isValidUrl(url));
    if (!parser) {
      throw new InvalidSource();
    }

    return await parser.getContentData(url);
  };

  const updateVideoContent = async (content: VideoContent) => {
    const oldContent = blockContent?.contentObject || {};
    await newContentObjectChanged(blockId, sectionId, oldContent, content);
  };

  const clearVideoContent = async () => {
    const oldContent = blockContent?.contentObject || {};
    await newContentObjectChanged(blockId, sectionId, oldContent, {});
  };

  return {
    getVideoDataFromUrl,
    updateVideoContent,
    clearVideoContent,
  };
};
